import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援',
  title1: 'NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援',
  introduction_text:
    'メディア関係者向けNPBスコア分析Webソリューションを開発しました。このプロジェクトは、無機質な数字情報をユーザーが楽しめるUI/UX設計を行いました。弊社はデザインからシステム開発、グロース支援まで一貫して実施しました。',
  company: 'データスタジアム株式会社',
  tag1text: 'クラウドネイティブ',
  tag1src: '/cases/cloudnative/',
  tag2text: 'UX/UI改善',
  tag2src: '/cases/uxui-improvement/',
  tag3text: 'フロントエンド開発',
  tag3src: '/cases/frontend-dev/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  color: '#fff',
  background: '#0E2B40',
  staff1: 'データスタジアム株式会社　配信サービス部 野球アナリスト 小林 展久さん',
  staff2: '映像・メディア事業推進部 　営業・新規事業担当 佐藤 一司さん ',
  image: '/images/img/cases/assistantrobo/top1.webp',
  alt: 'NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援',
  imgClass: 'fv_img_adjust2',
}

// プロジェクト概要
export const overviewTitle = 'タイムリーな操作性でユーザビリティの高い、クラウドネイティブなアプリケーションを開発'
export const overviewItem: OverviewItems[] = [
  {
    text: '「もっと野球をおもしろく」をテーマに、主にメディア関係者様向けにNPBスコア分析Webソリューションを提供。アイスリーデザインでは、デザインからシステム開発、グロース支援まで一貫してサポート。毎試合の一投一打の膨大なデータを対象に、ユーザーにはタイムリーに、かつストレスのない操作性を提供するべくオブジェクトの再利用やデータのキャッシュをうまく活用することで実現。また数字だけの一見無機質な情報を「ユーザーにもっとデータを楽しんでもらいたい」というコンセプトのもとUI/UX設計を行わせていただきました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'BtoBプロダクトの限界',
        text: '従来の野球スコア分析ツールは主にBtoB向けで、より広範なユーザー層にはアプローチが困難であった。',
      },
      {
        title: 'ユーザーエクスペリエンスの向上',
        text: 'ユーザーがデジタルリテラシーの高い層に限られず、広いユーザー層にアプローチするために使いやすいデザインと操作性の向上が求められていた。',
      },
      {
        title: '将来のBtoC展開',
        text: '野球ファンなどの一般消費者を対象とした将来的なBtoC展開に向けて、デザインや機能を広範なユーザー層に対応させる必要があった。',
      },
    ],
    solutions: [
      {
        title: '複数のアウトプット提案',
        text: 'ユーザーの要求に基づき複数のデザインや機能の選択肢を提供し、クライアントが最適なものを選べるようサポートした。',
      },
      {
        title: '現代的なデザインとUX設計',
        text: 'ユーザーインターフェースを現代的に仕上げ、広いユーザー層が使いやすいように詳細なUX設計を行った。',
      },
      {
        title: '継続的なサービス構築とグロース支援',
        text: 'ユーザーからのフィードバックに基づいてサービスを定期的に更新し、ブラッシュアップを続けることで、長期的にサービスを成長させる支援を提供した。',
      },
    ],
  },
]


// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
